import React from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import styled from "styled-components";
import Slider from "react-slick";

import { getCloudImageUrl, emptyImage } from "../../utils";

import ArrowPrev from "../../images/arrow/luxury_prev.png";
import ArrowNext from "../../images/arrow/luxury_next.png";
import isDefect from "../../images/is-defect.png";
// import CloseIcon from "../../images/close-button-black.png";
import CloseIcon from "../../images/cancel-x.png";

const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: 0px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowPrev} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: -10px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowNext} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  prevArrow: <PreviousArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function ModalProductDefect({ isOpen, toggle, dataProduct }) {
  function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
  let defects = [];
  const isDisplayItem = dataProduct.display_item;
  const isMissingAccessories = dataProduct.missing_accessories;
  const isYellowing = dataProduct.yellowing;
  const isDefectFromManufacture =
    dataProduct.sneakers_defect && dataProduct.category === "sneakers";

  if (isMissingAccessories) defects.push(capitalize("Missing Accessories"));
  if (isYellowing) defects.push(capitalize("Yellowing"));
  if (isDisplayItem) defects.push(capitalize("Display Item"));
  if (isDefectFromManufacture)
    defects.push(capitalize("Defects from Manufacture"));
  if (dataProduct.defects && dataProduct.defects.length > 0) {
    dataProduct.defects.map((t) => {
      defects.push(capitalize(t.name.split("_").join(" ")));
    });
  }
  
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-product-defect">
      <div className="defect-product-header-wrapper">
        <p>DEFECT DETAILS</p>
        <KickImage
          src={CloseIcon}
          alt="close-icon"
          onClick={toggle}
          style={{ cursor: "pointer" }}
        />
      </div>
      <ModalBody className="modal-product-defect-body-container">
        <div className="slider-container">
          <Slider {...settings} className="slider-content-container">
            {dataProduct &&
              dataProduct.sell &&
              dataProduct.sell.user_sell_images &&
              dataProduct.sell.user_sell_images.map((item, index) => {
                return item.URL ? (
                  <div key={item.id} className="defect-image-container">
                    <KickImage
                      src={getCloudImageUrl(item.URL, 400)}
                      alt="defect-product"
                    />
                  </div>
                ) : (
                  <div className="defect-image-container error-defect-image-container">
                    <KickImage
                      src={emptyImage(dataProduct.category)}
                      alt="defect-product"
                      onClick={toggle}
                    />
                  </div>
                );
              })}

            {dataProduct &&
              dataProduct.sell &&
              (!dataProduct.sell.user_sell_images || dataProduct.sell.user_sell_images.length == 0) && (
                <div className="defect-image-container error-defect-image-container">
                  <KickImage
                    src={emptyImage(dataProduct.category)}
                    alt="defect-product"
                    onClick={toggle}
                  />
                </div>
              )}
          </Slider>
        </div>
        <div className="defect-product-description">
          <div className="product-defect-list">
            <div className="defect-icon">
              <KickImage src={isDefect} alt="defect-img" />{" "}
            </div>{" "}
            <p className="paragraph">
              <span className="defect-text-inside-paragraph"> Defect:</span>{" "}
              <span>{defects.join(", ")}</span>
            </p>
          </div>
          <div className="additional-note">
            <i className="additional-note-text">Additional Notes</i>
            <p>{dataProduct.sell && dataProduct.sell.note}</p>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalProductDefect;